import { Button, Card, Checkbox, Select } from "components";
import { Controller, useFormContext } from "react-hook-form";
import { useToggle } from "utils";
import { BugetManagerFilter } from "../types";
import { DateFilter } from "components/widgets/DashboardFilter/components";
import moment from "moment";
import { ActualsEnum, PeriodeEnum } from "../enum";
import { FILTER_BUGET_MANAGER_DATA } from "../utils";

type FilterBugetManagerProps = {
  toggleDetail: ReturnType<typeof useToggle>
  toggleSubHeader: ReturnType<typeof useToggle>
  toggleZeroValue: ReturnType<typeof useToggle> 
  toggleAccountNumber: ReturnType<typeof useToggle>
  onFilterSubmit?: (data: BugetManagerFilter) => void
}

export const FilterBugetManager = (props: FilterBugetManagerProps) => {
  const methods = useFormContext<BugetManagerFilter>()

  const [range] = methods.watch(["range"])
  const enDate = moment().endOf("year").format("YYYY-MM-DD")

  const DROPDOWN_ACTUALS_DATA = [
    { value: ActualsEnum.OneMonth?.toString(), label: "1 Month" },
    { value: ActualsEnum.ThreeMonth?.toString(), label: "3 Month" },
    { value: ActualsEnum.SixMonth?.toString(), label: "6 Month" },
    { value: ActualsEnum.TwelveMonth?.toString(), label: "12 Month" }
  ]
  const DROPDOWN_PERIODE_DATA = [
    { value: PeriodeEnum.ThreeMonth?.toString(), label: "3 Month" },
    { value: PeriodeEnum.SixMonth?.toString(), label: "6 Month" },
    { value: PeriodeEnum.TwelveMonth?.toString(), label: "12 Month" }
  ]

  return (
    <section className="my-2">
      <Card>
        <Card.Body>
          <section className="container flex-col lg:flex lg:flex-row justify-center lg:justify-between items-end pt-5">
            <div className="w-full lg:w-full lg:flex lg:justify-start items-end">
              <div className="w-full lg:w-[200px] lg:me-4">
                <Controller
                  name="accountGroup"
                  control={methods.control}
                  render={({ field }) => (
                    <Select
                      label="Account Group"
                      placeholder="Select Filter"
                      className="w-full "
                      options={FILTER_BUGET_MANAGER_DATA}
                      onChange={(filter) => field.onChange(filter?.value)}
                      value={FILTER_BUGET_MANAGER_DATA.find((option) => option.value === field.value)}
                    />
                  )}
                />
              </div>

              <div className="lg:me-4">
                <DateFilter 
                  monthOnly
                  thirtyDatesMaximum
                  disabled
                  value={{ start_date: range!, end_date: enDate,  type: "Month" }}
                  onChangeStartDate={res => methods.setValue("range", res)}
                />
              </div>
    
              <div className="w-full lg:w-[200px] lg:me-4">
                <Controller
                  name="actuals"
                  control={methods.control}
                  render={({ field }) => (
                    <Select
                      label="Actuals"
                      placeholder="Select Actuals"
                      className="w-full "
                      options={DROPDOWN_ACTUALS_DATA}
                      onChange={(filter) => field.onChange(filter?.value)}
                      value={DROPDOWN_ACTUALS_DATA.find((option) => option.value?.toString() === field.value?.toString())}
                    />
                  )}
                />
              </div>

              <div className="w-full lg:w-[200px] lg:me-4">
                <Controller
                  name="periods"
                  control={methods.control}
                  render={({ field }) => (
                    <Select
                      label="Periode"
                      placeholder="Select Periode"
                      className="w-full "
                      options={DROPDOWN_PERIODE_DATA}
                      onChange={(filter) => field.onChange(filter?.value)}
                      value={DROPDOWN_PERIODE_DATA.find((option) => option.value?.toString() === field.value?.toString())}
                    />
                  )}
                />
              </div>
    
              <div className="w-full lg:w-[100px] lg:me-4">
                <Button
                  type="button"
                  permission="AP023"
                  disabled={methods.formState.isSubmitting}
                  onClick={() => methods.handleSubmit((data) => props?.onFilterSubmit && props?.onFilterSubmit(data))()}
                  className="w-full btn bg-black dark:bg-primary text-white dark:btn-primary rounded-lg"
                >
                  {methods.formState.isSubmitting && (<span className="loading loading-spinner" />)}
                  Update
                </Button>
              </div>
            </div>
    
            <div className="w-full lg:ms-4 mt-8 flex pb-1 justify-end items-center">
              <section className="px-2">
                <Checkbox
                  defaultChecked={props?.toggleDetail.isActive}
                  onChange={(e) => props?.toggleDetail.setActive(e.target.checked)}>
                  Detail
                </Checkbox>
              </section>
    
              <section className="px-2">
                <Checkbox
                  defaultChecked={props?.toggleSubHeader.isActive}
                  onChange={(e) => props?.toggleSubHeader.setActive(e.target.checked)}>
                  Sub Header
                </Checkbox>
              </section>
    
              <section className="px-2">
                <Checkbox
                  defaultChecked={props?.toggleZeroValue.isActive}
                  onChange={(e) => props?.toggleZeroValue.setActive(e.target.checked)}>
                  Zero Value
                </Checkbox>
              </section>
    
              <section className="px-2">
                <Checkbox
                  defaultChecked={props?.toggleAccountNumber.isActive}
                  onChange={(e) => props?.toggleAccountNumber.setActive(e.target.checked)}>
                  Account Number
                </Checkbox>
              </section>
            </div>
          </section>
        </Card.Body>
      </Card>
    </section>
  )
}